import React from "react";
import { isEditorPlugin } from "./../../ricos-editor/utils/is-editor-plugin";
const STATIC_OVERRIDES_COOKIE = "wixStaticsVersions";
const ARTIFACT_ID = "wix-ricos";
const QUERY_PARAM_KEY = `${ARTIFACT_ID}-override`;
const getQueryParam = (key) => {
  if (typeof window === "undefined") {
    return "";
  }
  const urlParams = new URLSearchParams(window.location.search);
  return decodeURIComponent(urlParams.get(key) || "");
};
const getCookie = (name) => {
  if (typeof document === "undefined") {
    return null;
  }
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(";").shift();
  }
  return null;
};
const getOverrideValue = () => {
  const overridesCookieValue = getCookie(STATIC_OVERRIDES_COOKIE);
  const cookiesValueMap = overridesCookieValue?.split("|").reduce((acc, cookie) => {
    const [key, value2] = cookie.split("#");
    return { ...acc, [key]: value2 };
  }, {});
  const value = getQueryParam(QUERY_PARAM_KEY) || cookiesValueMap?.[ARTIFACT_ID];
  if (!value) {
    return null;
  }
  return value;
};
const isValidHash = (hash) => {
  return /^[a-f0-9]+$/.test(hash);
};
const isValidVersion = (version) => {
  return /^\d+\.\d+\.\d+$/.test(version);
};
const getOverrideUrl = () => {
  const value = getOverrideValue();
  if (!value) {
    return null;
  }
  if (value.startsWith("http://localhost") || value.startsWith("https://localhost")) {
    const url = new URL(value);
    return `${url.href}${url.href.endsWith("/") ? "" : "/"}full-ricos-editor.js`;
  }
  if (isValidVersion(value) || isValidHash(value)) {
    return `https://static.parastorage.com/services/${ARTIFACT_ID}/${value}/full-ricos-editor.js`;
  }
  return null;
};
const wixInsiderOverrideUrl = getOverrideUrl();
const hasWixInsiderOverride = !!wixInsiderOverrideUrl;
const OverrideFullRicosEditorLazy = React.lazy(async () => {
  const bundled = await (0, eval)(`import('${wixInsiderOverrideUrl}')`);
  bundled.loadCSS();
  return { default: bundled.FullRicosEditor };
});
const OverridePluginsResolver = ({
  children,
  plugins,
  hasOverride
}) => {
  const [lazyPlugins, setLazyPlugins] = React.useState(null);
  React.useEffect(() => {
    const loadPlugins = async () => {
      const bundle = await (0, eval)(`import('${wixInsiderOverrideUrl}')`);
      setLazyPlugins(
        plugins?.map((plugin) => {
          if (isEditorPlugin(plugin)) {
            return bundle.pluginsMap[plugin.type](plugin.config);
          }
          return plugin;
        }) ?? []
      );
    };
    if (hasOverride) {
      loadPlugins();
    }
  });
  if (!hasOverride) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children(plugins ?? []));
  }
  if (!lazyPlugins) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children(lazyPlugins));
};
export {
  OverrideFullRicosEditorLazy,
  OverridePluginsResolver,
  getOverrideValue,
  hasWixInsiderOverride
};
//# sourceMappingURL=overrides.js.map
